<template>
  <label :for="name" class="checkbox-label flex items-center" :class="disabled ? 'text-gray-400 pointer-events-none' : ''">
    <input :id="name" :checked="value" @change="checkboxChanged" type="checkbox" class="checkbox" :disabled="disabled"/>
    <span class="ml-1">{{ label }}</span>
  </label>
</template>

<script>
  export default {
    props: {
      label: {},
      name: {required: true},
      disabled: {required: false},
      value: {required: false, default: false},
    },

    methods: {
      checkboxChanged(event) {
        this.$emit('input', event.target.checked);
      },
    },
  };
</script>
